export default __webpack_public_path__ + "static/media/resulta.16529d0b.svg";